import styled from 'styled-components'
export const Button = styled.button`
  background: linear-gradient(94.08deg, #71e1ff -0.49%, #e2a0ff 102.22%);
  border-radius: 8px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px 10px 20px;
  color: #5c1a00;
  font-family: 'Hey-Comic', sans-serif;
`
